import moment from 'moment';

const initState = {
  fetchData: {
    fetches: 0,
    fetchReports: false,
  },
  presistFilters: {
    aggregate_by: 'month',
    billing_end_date: moment.utc(moment().subtract(1, 'day')).format('YYYY-MM-DD'),
    billing_start_date: moment.utc(moment().subtract(1, 'month')).format('YYYY-MM-DD'),
    display_name: null,
    dp_name: 'All',
    dp_value: null,
    dsn: null,
    end_date: moment.utc(moment()
      .subtract(1, 'day'))
      .format('YYYY-MM-DD'),
    left_end_date: moment.utc(moment()
      .subtract(6, 'month')
      .subtract(1, 'day'))
      .format('YYYY-MM-DD'),
    left_start_date: moment.utc(moment()
      .subtract(1, 'year'))
      .format('YYYY-MM-DD'),
    logged_in_oem_id: null,
    notification_type: 'All',
    oem_id: null,
    oem_model: 'All',
    property_name: null,
    region_name:
      process.env.REACT_APP_IS_VPC_ENVIRNOMENT === 'true'
        ? 'US-VPC'
        : process.env.REACT_APP_IS_US_ENVIRNOMENT === 'true'
        ? 'US-FIELD'
        : process.env.REACT_APP_IS_EU_ENVIRNOMENT === 'true'
          ? 'EU'
          : 'US-FIELD',
    right_end_date: moment.utc(moment().subtract(1, 'day')).format('YYYY-MM-DD'),
    right_start_date: moment.utc(moment().subtract(6, 'month')).format('YYYY-MM-DD'),
    start_date: moment.utc(moment().subtract(1, 'month')).format('YYYY-MM-DD'),
    sw_version: 'All',
    year: moment.utc(moment()).format('YYYY'),
    duration: 'Monthly',
    period: 1
  },
};
export default initState;
